import React, { Fragment } from 'react'
import BackToTopSwitch from '../../components/BackToTopSwitch'
import CreateItemForm from '../../components/CreateItemForm'
import Footer from '../../layouts/Footer'
import Header from '../../layouts/Header'


const CreateItem = () => {
  return (
    <Fragment>
      {/* header */}
      <Header />
      {/* Popular collections */}
      <CreateItemForm />
      {/* Footer */}
      <Footer />
      {/*  */}
      <BackToTopSwitch />
    </Fragment>
  )
}

export default CreateItem